<template>
  <div class="custom-form cmi-res">
    <div class="panel-body">
      <div class="panel panel-info cmi-search-header-panel">
        <div class="row cmi-search-wrapper">
          <div class="col-md-10 col-md-offset-1">
            <div class="cmi-search-header">
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Select by resource label</span>
                </div>
                <div class="col-md-6 header-middle">
                  <select
                    id="res_FilterResLabel"
                    name="res_FilterResLabel"
                    @change="getFormDataByLabel"
                    v-model.trim="res_FilterResLabel"
                    class="form-control"
                  >
                    <option></option>
                    <option
                      v-for="item in resourceLabels"
                      v-bind:value="item.value"
                      :key="item.value"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
                <div class="col-md-2 header-right">
                  <span
                    v-if="aniLabelsLoading"
                    class="fa fa-spinner fa-spin fa-3x fa-fw"
                  ></span>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Search by resource code</span>
                </div>
                <div class="col-md-6 header-middle">
                  <masked-input
                    type="text"
                    name="res_FilterResCode"
                    class="form-control"
                    :mask="[
                      /[A-Z]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      ' ',
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i,
                      /[0-9A-F]/i
                    ]"
                    :guide="false"
                    :showMask="false"
                    :pipe="toUpperCase"
                    v-model.trim="res_FilterResCode"
                    spellcheck="false"
                  >
                  </masked-input>
                  <!--<input id="res_FilterResCode" name="res_FilterResCode" v-bind="res_FilterResCode" @input="toUpperCase" placeholder="resource code" class="form-control" />-->
                </div>
                <div class="col-md-2 cmi-search-header-btn-search">
                  <button
                    @click="getFormDataByCode"
                    v-bind:disabled="disableCriteriaMet_res_FilterResCode"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Search
                  </button>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-6 col-md-offset-3 cmi-search-header-btn-add">
                  <button
                    @click="newFormData"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Add new item
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Resource details</h3>
        </div>

        <div class="panel-body">
          <div v-if="showResourceCode" class="form-group">
            <label for="res_ResourceCode">Resource code</label>
            <div
              id="res_ResourceCode"
              name="res_ResourceCode"
              class="form-control cmi-file-label"
            >
              {{ fdata.res_ResourceCode }}
            </div>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_File') }"
          >
            <label for="res_File">Select main file</label>
            <input
              ref="res_File"
              id="res_File"
              name="res_File"
              @change="onFileChange_res_File"
              v-validate.initial="{
                required: validateFileInput,
                mimes: ['audio/*', 'video/*', 'image/*', 'application/pdf'],
                size: 2000000
              }"
              class="form-control"
              type="file"
            />
            <span class="help-block">{{ errors.first("res_File") }}</span>
          </div>

          <div class="form-group">
            <label for="res_FileName">Main file name and size</label>
            <div
              id="res_FileName"
              name="res_FileName"
              class="form-control cmi-file-label"
            >
              {{ fdata.res_FileName }}
            </div>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_IntroFile') }"
          >
            <label for="res_IntroFile">Select the intro (snippet) file</label>
            <input
              ref="res_IntroFile"
              id="res_IntroFile"
              name="res_IntroFile"
              @change="onFileChange_res_IntroFile"
              v-validate.initial="{
                mimes: ['audio/*', 'video/*', 'image/*', 'application/pdf'],
                size: 2000000
              }"
              class="form-control"
              type="file"
            />
            <span class="help-block">{{ errors.first("res_IntroFile") }}</span>
          </div>

          <div class="form-group">
            <label for="res_IntroFileName">Intro file name and size</label>
            <div
              id="res_IntroFileName"
              name="res_IntroFileName"
              class="form-control cmi-file-label"
            >
              {{ fdata.res_IntroFileName }}
            </div>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_Person') }"
          >
            <label for="res_Person">Preacher / Author / Speaker</label>
            <select
              id="res_Person"
              name="res_Person"
              v-model.trim="fdata.res_Person"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option
                v-for="item in peopleAtSite"
                v-bind:value="item.value"
                :key="item.value"
                >{{ item.label }}</option
              >
            </select>
            <span
              v-if="aniPeopleAtSiteLoading"
              class="fa fa-spinner fa-spin fa-3x fa-fw"
            ></span>
            <span class="help-block">{{ errors.first("res_Person") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_MessageDate') }"
          >
            <label for="res_MessageDate">Message date</label>
            <input
              id="res_MessageDate"
              name="res_MessageDate"
              v-model.trim="fdata.res_MessageDate"
              v-validate.initial="{
                required: true,
                valid_date_format: { active: true }
              }"
              placeholder="DD-MMM-YYYY"
              maxlength="11"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("res_MessageDate")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_MessageTrack') }"
          >
            <label for="res_MessageTrack">Track number</label>
            <select
              id="res_MessageTrack"
              name="res_MessageTrack"
              v-model="fdata.res_MessageTrack"
              class="form-control"
            >
              <option></option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            </select>
            <span class="help-block">{{
              errors.first("res_MessageTrack")
            }}</span>
          </div>
          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_MessageTitle') }"
          >
            <label for="res_MessageTitle">Message title</label>
            <textarea
              id="res_MessageTitle"
              name="res_MessageTitle"
              v-model.trim="fdata.res_MessageTitle"
              v-validate.initial="{ required: true, max: 200 }"
              maxlength="200"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("res_MessageTitle")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_MessageGenre') }"
          >
            <label for="res_MessageGenre">Message genre</label>
            <select
              id="res_MessageGenre"
              name="res_MessageGenre"
              v-model.number="fdata.res_MessageGenre"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Salvation</option>
              <option value="2">Faith</option>
              <option value="3">Hope</option>
              <option value="4">Perfection</option>
              <option value="97">Other</option>
            </select>
            <span class="help-block">{{
              errors.first("res_MessageGenre")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_MessageGenreText') }"
          >
            <label for="res_MessageGenreText">Specify message genre</label>
            <input
              id="res_MessageGenreText"
              name="res_MessageGenreText"
              v-model.trim="fdata.res_MessageGenreText"
              v-validate="{
                required: !disableCriteriaMet_res_MessageGenreText,
                max: 50
              }"
              v-bind:disabled="disableCriteriaMet_res_MessageGenreText"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("res_MessageGenreText")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_MessageCommentary') }"
          >
            <label for="res_MessageCommentary">Message commentary</label>
            <textarea
              id="res_MessageCommentary"
              name="res_MessageCommentary"
              v-model.trim="fdata.res_MessageCommentary"
              v-validate="{ max: 1000 }"
              maxlength="1000"
              rows="4"
              class="form-control"
            ></textarea>
            <span class="help-block">{{
              errors.first("res_MessageCommentary")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_FileThumbnail') }"
          >
            <label for="res_FileThumbnail"
              >Select cover image (thumbnail)</label
            >
            <select
              id="res_FileThumbnail"
              name="res_FileThumbnail"
              @change="onThumbnailChange"
              v-model.number="fdata.res_FileThumbnail"
              v-validate.initial="{ required: validateFileInput }"
              class="form-control"
            >
              <option></option>
              <option value="1">Audio thumbnail (image)</option>
              <option value="2">Video thumbnail (image)</option>
              <option value="97">Other</option>
            </select>
            <span class="help-block">{{
              errors.first("res_FileThumbnail")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_FileThumbnailOther') }"
          >
            <label for="res_FileThumbnailOther"
              >Browse to select cover image</label
            >
            <input
              ref="res_FileThumbnailOther"
              id="res_FileThumbnailOther"
              name="res_FileThumbnailOther"
              @change="onFileChange_res_FileThumbnailOther"
              v-validate="{ mimes: ['image/*'], size: 5000 }"
              v-bind:disabled="disableCriteriaMet_res_FileThumbnailOther"
              class="form-control"
              type="file"
            />
            <span class="help-block">{{
              errors.first("res_FileThumbnailOther")
            }}</span>
          </div>

          <div class="cmi-cover-image">
            <p>Cover image preview</p>
            <img
              ref="res_FileThumbnailPreview"
              class="img-thumbnail"
              v-bind:src="fdata.res_FileThumbnailPreview"
              alt="Cover image (thumbnail)"
            />
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_EventType') }"
          >
            <label for="res_EventType">Event</label>
            <select
              id="res_EventType"
              name="res_EventType"
              v-model="fdata.res_EventType"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Sunday Preaching</option>
              <option value="2">Leadership Conference</option>
              <option value="3">31st December Cross Over Night</option>
              <option value="97">Other</option>
            </select>
            <span class="help-block">{{ errors.first("res_EventType") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_EventTypeText') }"
          >
            <label for="res_EventTypeText">Please specify event</label>
            <input
              id="res_EventTypeText"
              name="res_EventTypeText"
              v-model.trim="fdata.res_EventTypeText"
              v-validate="{
                required: !disableCriteriaMet_res_EventTypeText,
                max: 50
              }"
              v-bind:disabled="disableCriteriaMet_res_EventTypeText"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("res_EventTypeText")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_PriceType') }"
          >
            <label for="res_PriceType">Price category</label>
            <select
              id="res_PriceType"
              name="res_PriceType"
              v-model.number="fdata.res_PriceType"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Free</option>
              <option value="2">Purchase</option>
            </select>
            <span class="help-block">{{ errors.first("res_PriceType") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_PriceCurrency') }"
          >
            <label for="res_PriceCurrency">Price currency</label>
            <select
              id="res_PriceCurrency"
              name="res_PriceCurrency"
              v-model="fdata.res_PriceCurrency"
              v-validate.initial="{
                required: !disableCriteriaMet_res_PriceCurrency
              }"
              v-bind:disabled="disableCriteriaMet_res_PriceCurrency"
              class="form-control"
            >
              <option></option>
              <option value="1">$ (Canadian Dollar - CAD)</option>
            </select>
            <span class="help-block">{{
              errors.first("res_PriceCurrency")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_Price') }"
          >
            <label for="res_Price">Price</label>
            <input
              id="res_Price"
              name="res_Price"
              v-model.trim="fdata.res_Price"
              v-validate.initial="{
                required: !disableCriteriaMet_res_Price,
                decimal: 2,
                max: 6
              }"
              v-bind:disabled="disableCriteriaMet_res_Price"
              maxlength="6"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("res_Price") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('res_ResStatus') }"
          >
            <label for="res_ResStatus">Product status</label>
            <select
              id="res_ResStatus"
              name="res_ResStatus"
              v-model="fdata.res_ResStatus"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">New</option>
              <option value="2">Labelled</option>
              <option value="3">Show in store</option>
              <option value="4">Hide from store</option>
              <option value="90">Delete</option>
            </select>
            <span class="help-block">{{ errors.first("res_ResStatus") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <modal
        name="alert-dialog-resources"
        :width="400"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>

      <div class="btn-submit-wrapper">
        <div v-if="showAnimation" class="cc-animation">
          <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
          <span class="form-progress-text">Form submission in progress</span>
        </div>
        <div class="cc-submit-btn-wrapper">
          <button
            @click="saveFormData"
            v-bind:disabled="showAnimation"
            type="submit"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
const path = "/dist/assets/images/ResourceImages/";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        res_ResourceCode: "",
        res_FileName: "",
        res_IntroFileName: "",
        res_FileThumbnail: 1,
        res_FileThumbnailOtherPath: "",
        res_PriceType: 1,
        res_PriceCurrency: null,
        res_Price: null,
        res_EventType: 1,
        res_EventTypeText: "",
        res_Person: null,
        res_MessageDate: moment().format("DD-MMM-YYYY"),
        res_MessageTrack: 1,
        res_MessageTitle: "",
        res_MessageGenre: 4,
        res_MessageGenreText: "",
        res_MessageCommentary: "",
        res_ResStatus: 1,
        res_FileThumbnailPreview: `${path}cmi_audio_008.png`
      },
      showAnimation: false,
      alertMessage: "",
      peopleAtSite: [],
      resourceLabels: [],
      res_FilterResLabel: "",
      res_FilterResCode: "",
      validateFileInput: true,
      aniLabelsLoading: false,
      aniPeopleAtSiteLoading: false,
      fd: new FormData()
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    saveFormData: async function() {
      this.fd.delete("json");
      this.fd.append("json", JSON.stringify(this.fdata));

      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-resources");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}UpdateFormData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fd, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }    
      if (rData != 0) {
        this.showAnimation = false;
        this.alertMessage =
          rData == -1
            ? "Duplicate Message date and Track number. Please check that Message date and Track number are correct. If you are uploading multiple files for same date, track number should be 1 , 2, 3  for first, second and third files respectively."
            : `Sorry system have encountered a technical issue when submitting this Form, please try again, if problem persists contact programmer on programmer@softmighty.com stating error code 'PRODUCT-FAILLED-TO-SUBMIT'`;
        this.$modal.show("alert-dialog-resources");
        return;
      }
      if (!this.fdata.pkey) {
        this.validateFileInput = true;
        this.resetFormData();
      }

      await this.getResourceLabels();
      this.alertMessage = "Your form has been submitted successfully";
      this.$modal.show("alert-dialog-resources");
      this.showAnimation = false;
    },
    getFormDataByLabel: async function() {
      this.res_FilterResCode = "";
      if (!this.res_FilterResLabel) {
        this.resetFormData();
        return;
      }

      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.res_FilterResLabel }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        this.setCoverImagePreview();
        this.$validator.errors.remove("res_File");
        this.validateFileInput = false;
      }
      this.aniLabelsLoading = false;
    },
    getFormDataByCode: async function() {
      this.res_FilterResLabel = "";
      const res_FilterResCode = this.res_FilterResCode.replace(/\s/g, "");
      if (!res_FilterResCode) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pcode: res_FilterResCode }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceDataByCode`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.fdata, rData);
        this.setCoverImagePreview();
        this.$validator.errors.remove("res_File");
        this.validateFileInput = false;
      } else {
        this.resetFormData();
        this.alertMessage = "Item not found";
        this.$modal.show("alert-dialog-resources");
      }

      this.aniLabelsLoading = false;
    },

    getResourceLabels: async function() {
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { siteId: 2 }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.resourceLabels, rData);
      }
      this.aniLabelsLoading = false;
    },

    getPeople: async function() {
      this.aniPeopleAtSiteLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}getPeople`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniPeopleAtSiteLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.peopleAtSite, rData);
      }
      this.aniPeopleAtSiteLoading = false;
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        pkey: 0,
        res_ResourceCode: "",
        res_FileName: "",
        res_IntroFileName: "",
        res_FileThumbnail: 1,
        res_FileThumbnailOtherPath: "",
        res_PriceType: 1,
        res_PriceCurrency: null,
        res_Price: null,
        res_EventType: 1,
        res_EventTypeText: "",
        res_Person: null,
        res_MessageDate: moment().format("DD-MMM-YYYY"),
        res_MessageTrack: 1,
        res_MessageTitle: "",
        res_MessageGenre: 4,
        res_MessageGenreText: "",
        res_MessageCommentary: "",
        res_ResStatus: 1,
        res_FileThumbnailPreview: `${path}cmi_audio_008.png`
      });
      this.fd = new FormData();
      this.$refs.res_File.value = null;
      this.$refs.res_FileThumbnailOther.value = null;
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-resources");
    },
    newFormData: function() {
      this.resetFormData();
      this.res_FilterResLabel = "";
      this.res_FilterResCode = "";
    },
    onFileChange_res_File: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.fd.delete("res_File");
      this.fd.append("res_File", files[0]);
      this.fdata.res_FileName = `${files[0].name} (${this.getFileSize(
        files[0].size
      )})`;
    },
    onFileChange_res_IntroFile: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.fd.delete("res_IntroFile");
      this.fd.append("res_IntroFile", files[0]);
      this.fdata.res_IntroFileName = `${files[0].name} (${this.getFileSize(
        files[0].size
      )})`;
    },
    onFileChange_res_FileThumbnailOther: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.fdata.per_FilePreview = "";
      this.fd.delete("res_FileThumbnailOther");
      this.fd.append("res_FileThumbnailOther", files[0]);

      this.res_FileThumbnailPreview = "";
      let reader = new FileReader();
      let self = this;
      reader.onload = function(e) {
        self.$refs.res_FileThumbnailPreview.src = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    onThumbnailChange: function() {
      this.$validator.errors.remove("res_FileThumbnailOther");
      this.$refs.res_FileThumbnailOther.value = null;
      this.setCoverImagePreview();
    },
    getFileSize: function(size) {
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (size == 0) return "0 Byte";
      let i = Math.floor(Math.log(size) / Math.log(1024));
      return (
        Math.round((size / Math.pow(1024, i)) * 100) / 100 + " " + sizes[i]
      );
    },
    toUpperCase: function(value) {
      return value.toUpperCase();
    },
    setCoverImagePreview: function() {
      if (this.fdata.res_FileThumbnail == 1) {
        this.fdata.res_FileThumbnailPreview = `${path}cmi_audio_008.png`;
      } else if (this.fdata.res_FileThumbnail == 2) {
        this.fdata.res_FileThumbnailPreview = `${path}cmi_video_cover_02.jpg`;
      } else if (
        this.fdata.res_FileThumbnail == 97 &&
        this.fdata.res_FileThumbnailOtherPath
      ) {
        this.fdata.res_FileThumbnailPreview = `${this.fdata.res_FileThumbnailOtherPath}`;
      } else {
        this.fdata.res_FileThumbnailPreview = `${path}cmi_no_image.jpg`;
      }
    }
  },
  watch: {
    disableCriteriaMet_res_EventTypeText: function(newValue) {
      if (newValue == true) this.fdata.res_EventTypeText = "";
    },
    disableCriteriaMet_res_MessageGenreText: function(newValue) {
      if (newValue == true) this.fdata.res_MessageGenreText = "";
    },
    disableCriteriaMet_res_PriceCurrency: function(newValue) {
      if (newValue == true) this.fdata.res_PriceCurrency = null;
    },
    disableCriteriaMet_res_Price: function(newValue) {
      if (newValue == true) this.fdata.res_Price = null;
    }
  },
  computed: {
    disableCriteriaMet_res_FileThumbnailOther: function() {
      if (
        this.fdata.res_FileThumbnail != null &&
        [97].indexOf(this.fdata.res_FileThumbnail) != -1
      ) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_res_EventTypeText: function() {
      if (
        this.fdata.res_EventType != null &&
        [97].indexOf(this.fdata.res_EventType) != -1
      ) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_res_MessageGenreText: function() {
      if (
        this.fdata.res_MessageGenre != null &&
        [97].indexOf(this.fdata.res_MessageGenre) != -1
      ) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_res_PriceCurrency: function() {
      if (
        this.fdata.res_PriceType != null &&
        [2].indexOf(this.fdata.res_PriceType) != -1
      ) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_res_Price: function() {
      if (
        this.fdata.res_PriceType != null &&
        [2].indexOf(this.fdata.res_PriceType) != -1
      ) {
        return false;
      }
      return true;
    },
    showResourceCode: function() {
      if (this.fdata.res_ResourceCode) {
        return true;
      }
      return false;
    },
    disableCriteriaMet_res_FilterResCode: function() {
      if (this.res_FilterResCode && this.res_FilterResCode.length == 16) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.getPeople();
    await this.getResourceLabels();
  }
};
</script>
